import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=048e056e&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=048e056e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e056e",
  null
  
)

export default component.exports